/* Copyright (C) 2023 Advenio Tecnosys Pvt. Ltd.

*        All Rights Reserved

*

 * NOTICE: 

 * All information contained herein is, and remains

* the property of Advenio Tecnosys and its suppliers,

* if any.  The intellectual and technical concepts contained

* herein are proprietary to Advenio Tecnosys

* and its suppliers and may be covered by Indian, U.S. and Foreign Patents,

* patents in process, and are protected by trade secret or copyright law.

* Appropriation, redistribution, dissemination of this information or reproduction

* of this material is strictly forbidden unless prior written permission is obtained

* from Advenio Tecnosys Pvt. Ltd.

*

* Author: < codebhendi, Ravi Ranjan Kumar,  Mylavarapu Sarath Sai, Sanket, Ujjwal Singh >

*/
import axios from "axios";
import { baseURL, syncBaseUrl } from "database/onlineDb/baseUrl";
import { isOffline, NETWORK_OFFLINE, OFFLINE_MESSAGE } from "realtime/netGuard";

export const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;

const rejectWhenOffline = (instance) => {
  instance.interceptors?.request?.use?.((config) => {
    if (isOffline()) {
      return Promise.reject({
        code: NETWORK_OFFLINE,
        message: OFFLINE_MESSAGE,
        offline: true,
        config,
      });
    }
    return config;
  });
};

export const client = axios.create({
  baseURL: baseURL,
  headers: {
    "Content-Type": "application/json",
    timezone,
  },
});
rejectWhenOffline(client);
export const syncClient = axios.create({
  baseURL: syncBaseUrl,
  headers: {
    "Content-Type": "application/json",
    timezone,
  },
});
rejectWhenOffline(syncClient);
rejectWhenOffline(axios);
export const fetchClient = async (endpoint, customConfig) => {
  const config = {
    method: "GET",
    mode: "cors",
    ...customConfig,
    timezone,
  };
  return window
    .fetch(`${baseURL}${endpoint}`, config)
    .then(handleErrors)
    .then((res) => res.json());
};
function handleErrors(response) {
  if (!response.ok) {
    throw Error(response.statusText);
  }
  return response;
}
